import { gql } from '@apollo/client';

// Household Queries
export const GET_HOUSEHOLD = gql`
  query GetHousehold($id: ID!) {
    getHousehold(id: $id) {
      id
      name
      ownerId
      members
      settings {
        location
        weeklyBudget
        mealPrepTime
        dietaryPreferences
        allergies
        equipment
      }
      createdAt
      updatedAt
    }
  }
`;

export const LIST_USER_HOUSEHOLDS = gql`
  query ListUserHouseholds {
    listUserHouseholds {
      id
      name
      ownerId
      members
      settings {
        location
        weeklyBudget
      }
      createdAt
    }
  }
`;

// Pantry Queries
export const LIST_PANTRY_ITEMS = gql`
  query ListPantryItems($householdId: ID!) {
    listPantryItems(householdId: $householdId) {
      householdId
      itemId
      name
      category
      quantity
      unit
      expiryDate
      addedDate
      normalizedIngredientId
      perishabilityScore
      updatedAt
    }
  }
`;

export const GET_EXPIRING_ITEMS = gql`
  query GetExpiringItems($householdId: ID!, $days: Int!) {
    getExpiringItems(householdId: $householdId, days: $days) {
      householdId
      itemId
      name
      category
      quantity
      unit
      expiryDate
      perishabilityScore
    }
  }
`;

// Meal Plan Queries
export const GET_MEAL_PLAN = gql`
  query GetMealPlan($householdId: ID!, $planId: ID!) {
    getMealPlan(householdId: $householdId, planId: $planId) {
      householdId
      planId
      weekStart
      weekEnd
      planSlots {
        date
        mealType
        recipeId
        recipeName
        recipeImage
        recipeStub {
          id
          title
          image
          readyInMinutes
          servings
          sourceUrl
          summary
          nutrition {
            calories
            protein
            carbs
            fat
          }
        }
        status
        servings
      }
      nutritionSummary {
        dailyAverages {
          calories
          protein
          carbs
          fat
          fiber
          sugar
          sodium
        }
        weeklyTotals {
          calories
          protein
          carbs
          fat
          fiber
          sugar
          sodium
        }
      }
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_ACTIVE_MEAL_PLAN = gql`
  query GetActiveMealPlan($householdId: ID!) {
    getActiveMealPlan(householdId: $householdId) {
      householdId
      planId
      weekStart
      weekEnd
      planSlots {
        date
        mealType
        recipeName
        recipeImage
        status
        servings
      }
      status
    }
  }
`;

// Grocery List Queries
export const LIST_GROCERY_LISTS = gql`
  query ListGroceryLists($householdId: ID!, $limit: Int) {
    listGroceryLists(householdId: $householdId, limit: $limit) {
      householdId
      listId
      planId
      items {
        id
        name
        quantity
        unit
        category
        aisle
        checked
        recipeIds
        notes
      }
      instacartLinkUrl
      status
      createdAt
      updatedAt
    }
  }
`;

export const GET_GROCERY_LIST = gql`
  query GetGroceryList($householdId: ID!, $listId: ID!) {
    getGroceryList(householdId: $householdId, listId: $listId) {
      householdId
      listId
      planId
      items {
        id
        name
        quantity
        unit
        category
        aisle
        checked
        recipeIds
        notes
      }
      instacartLinkUrl
      status
      createdAt
      updatedAt
    }
  }
`;

export const EXPORT_GROCERY_LIST = gql`
  query ExportGroceryList($householdId: ID!, $listId: ID!, $format: String!) {
    exportGroceryList(householdId: $householdId, listId: $listId, format: $format)
  }
`;

// Recipe Queries
export const SEARCH_RECIPES = gql`
  query SearchRecipes($query: String!, $filters: RecipeFilters) {
    searchRecipes(query: $query, filters: $filters) {
      id
      title
      image
      readyInMinutes
      servings
      sourceUrl
      summary
      cuisines
      dishTypes
      diets
      nutrition {
        calories
        protein
        carbs
        fat
      }
    }
  }
`;

// Member Queries
export const GET_HOUSEHOLD_MEMBERS = gql`
  query GetHouseholdMembers($householdId: ID!) {
    getHouseholdMembers(householdId: $householdId) {
      householdId
      userId
      name
      email
      diet
      allergies
      dislikes
      preferences
      spiceLevel
      role
      createdAt
      updatedAt
    }
  }
`;
